module.exports = __webpack_public_path__ + "img/customer-service.ae4a044a.svg";